export default __webpack_public_path__ + "static/media/shopifyLogo.53ab699a.svg";